import { Col, Row } from "antd";
import CardCollapse from "../../../Common/CardCollapse";
import { BATTERY_STATUS } from "../../../Common/Grafana/Constants";
import PanelsRow from "../../../Common/Grafana/PanelsRow";
import { getGrafanaBaseURL } from "../../../Common/Utils";

const SensorPanels = ({ chartType, 
  baseBatteryStackFilterObject,
  baseBatteryCellFilterObject }) => {
  return (
    <CardCollapse
      cardClassName="cardless-collapse"
      icon={null}
      title={null}
      subContent={null}
    >
      <Row className="pd0">
        <Col span={24}>
          <PanelsRow
            title="Cell Data"
            url={getGrafanaBaseURL(
              BATTERY_STATUS.VEHICLE.DASHBOARD_ID,
              BATTERY_STATUS.VEHICLE.DASHBOARD_NAME
            )}
            timeSeriesPanel={
              chartType?.timeSeries &&
              BATTERY_STATUS.VEHICLE.PANEL_ID["cellData"]["timeSeries"]
            }
            histogramPanel={
              chartType?.histogram &&
              BATTERY_STATUS.VEHICLE.PANEL_ID["cellData"]["histogram"]
            }
            boxPlotPanel={
              chartType?.boxPlot &&
              BATTERY_STATUS.VEHICLE.PANEL_ID["cellData"]["boxPlot"]
            }
            baseFilterObject={baseBatteryCellFilterObject}
            variableKeys={BATTERY_STATUS.VEHICLE.BASE_VARIABLES}
          />
        </Col>
      </Row>
      <Row className="pd0">
        <Col span={24}>
          <PanelsRow
            title="Sensor Data"
            url={getGrafanaBaseURL(
              BATTERY_STATUS.VEHICLE.DASHBOARD_ID,
              BATTERY_STATUS.VEHICLE.DASHBOARD_NAME
            )}
            timeSeriesPanel={
              chartType?.timeSeries &&
              BATTERY_STATUS.VEHICLE.PANEL_ID["sensorData"]["timeSeries"]
            }
            histogramPanel={
              chartType?.histogram &&
              BATTERY_STATUS.VEHICLE.PANEL_ID["sensorData"]["histogram"]
            }
            boxPlotPanel={
              chartType?.boxPlot &&
              BATTERY_STATUS.VEHICLE.PANEL_ID["sensorData"]["boxPlot"]
            }
            baseFilterObject={baseBatteryStackFilterObject}
            variableKeys={BATTERY_STATUS.VEHICLE.BASE_VARIABLES}
          />
        </Col>
      </Row>
    </CardCollapse>
  );
};

export default SensorPanels;
